import Accordion from 'accordion-js';

export default function initAccordion() {
  const accordionContainers = document.querySelectorAll('.accordion-container');

  if (!accordionContainers.length) {
    return;
  }

  accordionContainers.forEach((container) => {
    new Accordion(container, {
      openOnInit: [0],
    });
  });
}